
export const parseHex = (c: string) => {
    if (!c || typeof c !== 'string') return [0, 0, 0];
    if (c.startsWith('#')) c = c.slice(1);
    if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    const v = parseInt(c, 16);
    if (isNaN(v)) return [0, 0, 0];
    return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
};

export const lerpColor = (a: string, b: string, t: number) => {
  const c1 = parseHex(a);
  const c2 = parseHex(b);
  const r = Math.round(c1[0] + (c2[0] - c1[0]) * t);
  const g = Math.round(c1[1] + (c2[1] - c1[1]) * t);
  const bl = Math.round(c1[2] + (c2[2] - c1[2]) * t);
  return `rgb(${r},${g},${bl})`;
};

export const getRandomColor = (): string => {
  const colors = [
    '#ef4444', '#f97316', '#f59e0b', '#10b981', 
    '#3b82f6', '#6366f1', '#8b5cf6', '#d946ef', 
    '#ec4899', '#f43f5e'
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};
